export const CURRENCY_STORAGE_KEY = 'legal365.currency';
export const DEFAULT_CURRENCY = 'CLP';

export const SUPPORTED_CURRENCIES = [
  { code: 'CLP', symbol: '$', name: 'Chilean Peso', locale: 'es-CL' },
  { code: 'USD', symbol: '$', name: 'US Dollar', locale: 'en-US' },
  { code: 'EUR', symbol: '€', name: 'Euro', locale: 'de-DE' },
  { code: 'GBP', symbol: '£', name: 'Pound Sterling', locale: 'en-GB' },
  { code: 'MXN', symbol: '$', name: 'Mexican Peso', locale: 'es-MX' },
  { code: 'ARS', symbol: '$', name: 'Argentine Peso', locale: 'es-AR' },
  { code: 'PEN', symbol: 'S/', name: 'Peruvian Sol', locale: 'es-PE' },
  { code: 'COP', symbol: '$', name: 'Colombian Peso', locale: 'es-CO' },
  { code: 'BRL', symbol: 'R$', name: 'Brazilian Real', locale: 'pt-BR' },
  { code: 'CLF', symbol: 'UF', name: 'UF', locale: 'es-CL' },
];

const SUPPORTED_CURRENCY_CODES = new Set(
  SUPPORTED_CURRENCIES.map((c) => c.code)
);

export function normalizeCurrency(code) {
  if (!code) return DEFAULT_CURRENCY;
  const upper = `${code}`.trim().toUpperCase();
  return SUPPORTED_CURRENCY_CODES.has(upper) ? upper : DEFAULT_CURRENCY;
}

export function getCurrencyByCode(code) {
  if (!code) return undefined;
  const upper = `${code}`.trim().toUpperCase();
  return SUPPORTED_CURRENCIES.find((c) => c.code === upper);
}

export function getCurrencyByName(name) {
  if (!name) return undefined;
  const lower = `${name}`.trim().toLowerCase();
  return SUPPORTED_CURRENCIES.find((c) => c.name.toLowerCase() === lower);
}

export function normalizeCurrencyCode(code) {
  if (!code) return '';
  return `${code}`.trim().toUpperCase();
}
